import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router'
import { selectUserType } from '../layout/store/slice'
import { COMPONENTS } from '../routers/constants'
import { USER_TYPE } from '../utils/authorization'
import { selectCompanyInfo } from './common/header/companyInfo/store/slice'

export const ValidateBoughtReport = ({ children }) => {
  const location = useLocation()

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const data = useSelector(selectCompanyInfo)
  const userType = useSelector(selectUserType)

  if (
    [USER_TYPE.PREMIUM, USER_TYPE.STANDARD, USER_TYPE.TRIAL].includes(
      userType.userTypeId,
    ) ||
    (data?.viewLiteFree && USER_TYPE.LITE === userType.userTypeId)
  ) {
    return children
  }

  return (
    <Navigate
      to={`${COMPONENTS.domesticSearch.components.domesticSearchPreview.route}?organizationId=${params.organizationId}`}
      replace={true}
    />
  )
}
